import React from 'react';
import propTypes from 'prop-types';

import { Pagination, PageList, Page, PageLink, PageEllipsis } from 'src/ui/mui-ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function UiPagination({
  currentPage,
  totalItems,
  itemsPerPage,
  onNextPage,
  onPrevPage,
  onGoToPage,
}) {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const isFirstPage = currentPage === 0;
  const isLastPage = currentPage === totalPages - 1;
  const pagesLinks = [];

  const getPageLink = pageNumber => {
    const isCurrent = pageNumber === currentPage;
    const pageLabel = pageNumber + 1;

    return (
      <Page key={pageNumber}>
        <PageLink
          isCurrent={isCurrent}
          onClick={!isCurrent ? () => onGoToPage(pageLabel) : null}
        >
          {pageLabel}
        </PageLink>
      </Page>
    );
  };

  let hasLeftEllipsis = false;
  let hasRightEllipsis = false;
  const firstPage = getPageLink(0);
  const lastPage = totalPages > 1 ? getPageLink(totalPages - 1) : null;

  if (totalPages <= 7) {
    for (let i = 1; i < totalPages - 1; i += 1) {
      pagesLinks.push(getPageLink(i));
    }
  } else if (currentPage < 3) {
    pagesLinks.push(getPageLink(1));
    pagesLinks.push(getPageLink(2));
    hasRightEllipsis = true;
  } else if (currentPage >= totalPages - 3) {
    pagesLinks.push(getPageLink(totalPages - 3));
    pagesLinks.push(getPageLink(totalPages - 2));
    hasLeftEllipsis = true;
  } else {
    pagesLinks.push(getPageLink(currentPage - 1));
    pagesLinks.push(getPageLink(currentPage));
    pagesLinks.push(getPageLink(currentPage + 1));
    hasLeftEllipsis = true;
    hasRightEllipsis = true;
  }

  return (
    totalItems > 0 && (
      <Pagination isAlign="centered" isSize="small" className="ui-pagination">
        <PageList>
          <Page>
            <PageLink
              disabled={isFirstPage}
              onClick={!isFirstPage ? onPrevPage : null}
            >
              <span className="icon is-small">
                <FontAwesomeIcon icon={['fal', 'chevron-left']} size="xs" />
              </span>
            </PageLink>
          </Page>
          {firstPage}
          {hasLeftEllipsis && (
            <Page>
              <PageEllipsis />
            </Page>
          )}
          {pagesLinks}
          {hasRightEllipsis && (
            <Page>
              <PageEllipsis />
            </Page>
          )}
          {lastPage}
          <Page>
            <PageLink
              disabled={isLastPage}
              onClick={!isLastPage ? onNextPage : null}
            >
              <span className="icon is-small">
                <FontAwesomeIcon icon={['fal', 'chevron-right']} size="xs" />
              </span>
            </PageLink>
          </Page>
        </PageList>
      </Pagination>
    )
  );
}

UiPagination.propTypes = {
  currentPage: propTypes.number.isRequired,
  totalItems: propTypes.number.isRequired,
  itemsPerPage: propTypes.number.isRequired,
  onNextPage: propTypes.func.isRequired,
  onPrevPage: propTypes.func.isRequired,
  onGoToPage: propTypes.func.isRequired,
};
